import React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import type { NodeEvent } from '../../../types/uncinc_profile/nodes';
import NodeEventTeaser from './Teaser';
import NodeEventPage from './Page';

interface NodeEventProps {
  entity: ImmutableEntity<NodeEvent>;
  viewMode: string;
  classes: string;
}

const NodeEventWrapper: React.FC<NodeEventProps> = ({ entity, viewMode, classes = '' }) => {
  switch (viewMode) {
    case 'teaser':
      return <NodeEventTeaser entity={entity} classes={classes} />;
    default:
      return <NodeEventPage entity={entity} />;
  }
};

export default NodeEventWrapper;
